"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FilePlaybackTime {
    constructor({ seconds }) {
        this.toJSON = () => ({
            seconds: this.seconds,
        });
        this.seconds = seconds;
    }
}
FilePlaybackTime.fromJSON = (json) => {
    const { seconds } = Object.assign({}, json);
    if (typeof seconds !== 'number' || Number.isNaN(seconds))
        throw new Error('.seconds must be a number');
    return new FilePlaybackTime({ seconds });
};
exports.default = FilePlaybackTime;
